module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/american-football-d0e16d9f5728c17a3e75b2d2220f0cb5.svg";